<template>
  <div class="bill">
    <van-sticky>
      <van-nav-bar
        left-arrow
        :border="false"
        @click-left="onClickLeft"
      ><template #left>
        <span class="iconfont icon-houtui fs-24 fw-700"></span>
        </template>
        <template #title>
          <strong>账单核对</strong>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-sticky :offset-top="46">
      <div class="filter flex align-center justify-between">
        <div class="filter-item" @click="show = true">
          <span>{{ filterTime }}</span>
          <van-icon name="arrow-down" class="ml-5" />
        </div>
        <van-action-sheet v-model="show">
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="选择年月"
            :formatter="formatter"
            confirm-button-text="完成"
            @cancel="show = false"
            @confirm="filter"
          />
        </van-action-sheet>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" class="flex-1" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      ><div class="card-list">
          <mr-card v-for="(item, index) in music" :key="index" :title="item.title" :content="item.content" :free="item.free" :download="item.download" :pay="item.pay" :sale="item.sale" :allow="true" :to="item.to" class="mt-15">
            <template #footer>
              <div class="footer">
                <van-button v-if="!item.disabled" color="#FC3159" block class="radius-15" @click.native="sureBill(item)">确认</van-button>
                <van-button v-else color="#B7BDCA" block class="radius-15" :disabled="item.disabled">已确认</van-button>
              </div>
            </template>
          </mr-card>
        </div>
        <template v-if="music.length > 0" #finished>
          <span>没有更多了</span>
        </template>
        <van-empty v-if="music.length === 0" description="暂无数据" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Filter from '@/filters/index'
import { getBillList, confirmBill } from '@/api/music'
let keepAlive = false
export default {
  name: 'Bill',
  beforeRouteEnter (to, from, next) {
    keepAlive = from.meta.keepAlive ? true : false
    next()
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      show: false,
      currentDate: new Date(), // 日期选择器的时间，实时变化的
      date: '', // 当前显示的筛选的日期
      title: {
        label: 'SP名称',
        content: '酷我音乐'
      },
      content: {
        label: '总金额',
        total: '',
        unit: '￥'
      },
      music: [], // 列表数据
      currentPage: 0
    }
  },
  computed: {
    filterTime() {
      const name = Filter.formatTime(this.date, '{y}-{m}') === Filter.formatTime(new Date(), '{y}-{m}') ? '本月' : Filter.formatTime(this.date, '{y}-{m}')
      return name
    }
  },
  activated() {
    this.$nextTick(() => {
      if (!keepAlive) {
        this.getBillList('refresh')
      }
    })
  },
  methods: {
    async getBillList(type) {
      const res = await getBillList({ page: this.currentPage, bill_time: Filter.formatTime(this.date, '{y}-{m}') })
      const data = res.data
      this.currentPage = +data.current_page // 隐士转化为Number类型
      const list = data.data.map(val => ({
        title: {
          label: 'SP名称',
          content: val.sp_name +  '('+ (val.company_id === 1 ? '渠道一' : '渠道二') +')'
        },
        content: {
          label: '总金额',
          total: Number(val.cp_money),
          unit: '￥'
        },
        disabled: val.is_confirm === '已确认',
        free: val.free_num,
        download: val.down_num,
        pay: val.pay_num,
        sale: val.sale_num,
        bill_time: val.bill_time,
        sp_name: val.sp_name,
        company_id: val.company_id,
        to: '/bill-list?name=' + val.sp_name + '&time=' + val.bill_time + '&company_id=' + val.company_id
      }))
      if (type === 'refresh') { // 下拉刷新
        this.music = list
      } else { // 上拉加载
        this.music = [...this.music, ...list]
      }
      return list.length
    },
    async onRefresh() {
      this.currentPage = 1
      await this.getBillList('refresh')
      this.$toast('刷新成功')
      this.isLoading = false
      this.finished = false
    },
    async onLoad() {
      this.loading = true
      this.currentPage = this.currentPage + 1
      const length = await this.getBillList()
      if (length < 1) {
        this.finished = true
      }
      this.loading = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onClickLeft() {
      this.$router.replace('/me')
    },
    async filter(time) {
      this.date = time
      this.show = false
      // 进行请求接口
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        await this.getBillList('refresh')
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async sureBill(item) {
      const params = {
        time: item.bill_time,
        sp_name: item.sp_name,
        company_id: item.company_id,
        platform: 'android'
      }
      try {
        await this.$store.commit('TOGGLE_LOADING', true)
        const res = await confirmBill(params)
        if (res.code === 1) {
          this.$toast(res.msg)
          item.disabled = true
        }
      } finally {
        await this.$store.commit('TOGGLE_LOADING', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bill{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: calc(100vh - 46Px - 50px);
  }
}
.card-list{
  padding: 0 15px;
}
.filter{
  padding: 10px 16px;
  background-color: #fff;
  .filter-item{
    display: flex;
    align-items: center;
    padding: 5px 15px;
    border-radius: 5px;
    background-color: #F3F4F6;
  }
}
</style>
